import { useEffect, useState } from "react";
import { getStudent } from "../services/scpApi";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import SelectStudent from "../features/selectStudent/SelectStudent";
import UpdateStudentProgress from "../pages/updateStudentProgress/UpdateStudentProgress";
import StudentProgress from "../pages/studentProgress/StudentProgress";

const PortalStudent = ({children}) => {
    const [currentPeriod, setCurrentPeriod] = useState();
    const [student, setStudent] = useState({});
    const [activeTab, setActiveTab] = useState('update-student-progress');
    const selectedStudent = useSelector(state => state.portalSelected.selectedStudent);
    const location = useLocation();

    useEffect(() => {
        console.log("Selected student: ", selectedStudent);
    }, [selectedStudent])

    // set tab based on the current location
    useEffect(() => {
        const path = location.pathname.split('/').pop();
        console.log("Current path: ", path);
        setActiveTab(path);
    }, [location]);

    useEffect(() => {
        if (!selectedStudent || !selectedStudent.id) {
            setStudent({});
            setCurrentPeriod();
            return;
        }

        (async () => {
            try {
                const studentData = await getStudent(selectedStudent.id);
                setStudent(studentData);
                console.log("Student data: ", studentData);

                if (studentData.pupil_periods) {
                    let lastPeriod = studentData.pupil_periods[studentData.pupil_periods.length - 1];
                    setCurrentPeriod(lastPeriod);
                }

            } catch (error) {
                console.log(error);
            }
        })();

    }, [selectedStudent])

    const renderTab = () => {
        switch (activeTab) {
            case "update-student-progress":
                return <UpdateStudentProgress />
            case "progress-tracking":
                return <StudentProgress />
            default:
                return <p>Select a tab to view content.</p>;
        }
    }

    console.log('CURRENT ACTIVE TAB: ', activeTab);

    return (
        <div className="student-layout">
            <SelectStudent />
            <div className="separator"></div>
            {/* student details */}
            <div className="student-details-cont">
                <div className="student-details">
                    {selectedStudent && selectedStudent.id ? (
                        <>
                            <div className="student-details-cont">
                                <h3>{student.name} {currentPeriod && ` - Year ${currentPeriod.year_group}`} {student.school && student.school.name && ` - ${student.school.name}`}</h3>
                                {/* <p>{`${currentPeriod.period_name} ${currentPeriod.calendar_year}`}</p> */}
                            </div>
                            <div className="tabs">
                                <div className={`tab ${activeTab == 'update-student-progress' ? "active" : ""}`}>
                                    <Link to="update-student-progress"><p>Roadmap</p></Link>
                                </div>
                                <div className={`tab ${activeTab == 'progress-tracking' ? "active" : ""}`}>
                                    <Link to="progress-tracking"><p>Progress Tracking</p></Link>
                                </div>
                                <div className={`tab ${activeTab == 'baseline' ? "active" : ""}`}>
                                    <Link to="baseline"><p>Baseline</p></Link>
                                </div>
                                <div className={`tab ${activeTab == 'notes' ? "active" : ""}`}>
                                    <Link to="notes"><p>Notes</p></Link>
                                </div>
                                <div className={`tab ${activeTab == 'edit-details' ? "active" : ""}`}>
                                    <Link to="edit-details"><p>Edit Details</p></Link>
                                </div>
                            </div>

                            <div className="separator"></div>

                            {children}
                        </>
                    ) : (
                        <p>Please select a student to view details.</p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PortalStudent;